<template>
    <section class="section section-shaped section-lg my-0 mt-5 booking" :class="oracle.isMobile() ? '' :'p-5'">
        <div class="d-flex flex-column p-3"
             :class="oracle.isMobile() ? 'w-100 booking-margin' :'mt-5 card shadow rounded-xl'">
            <div :class="oracle.isMobile() ? (isEN?'flex-column-reverse':'flex-column') : (isEN?'flex-row-reverse':'flex-row')"
                 class="d-flex mt-3" style="margin-right: auto; margin-left: auto;"
                 :style="oracle.isMobile() ? 'align-items: center' : 'align-items: end'">
                <img :src="require('@/assets/image/icef-logo.webp')" class="logo-booking">
                <span style="font-size: 11px; font-weight: bold; font-style: oblique" class="mr-3">Powered by</span>
            </div>
            <div class="title-booking mt-3 d-flex" :class="oracle.isMobile() ? 'flex-column mt-5' : 'flex-row'"
                 :style="oracle.isMobile() ? 'align-items: center' : 'align-items: center'"
                 style="font-weight: bold; margin-right: auto; margin-left: auto">
                {{language.lang('Confirmation service via')}} <img :src="require('@/assets/image/booking.png')"
                                                                   class="image-logo-booking">
                {{language.lang('In order to present to the embassy')}}
            </div>
            <div class="d-flex flex-column mt-5" :class="oracle.isMobile() ? 'mr-2 ml-2' : 'mr-5 ml-5'">
                <div class="d-flex flex-row hint-booking">
                    <div class="counter-booking">
                        <span>1</span>
                    </div>
                    <p>
                        {{language.lang('First, put the link of your desired accommodation through Booking.com in the box below.')}}
                    </p>
                </div>
                <v-col :cols="oracle.isMobile() ? '12' : '7' " class="mr-auto">
                    <v-text-field
                            rounded v-model="address" persistent-hint outlined type="text"
                            :hint="language.lang('The address must start with https://www.booking.com.')"
                    ></v-text-field>
                </v-col>
            </div>
            <div :class="oracle.isMobile() ? 'ml-2 mr-2' : 'mr-5 ml-5'" class="d-flex flex-column mt-5">
                <div class="d-flex flex-row hint-booking">
                    <div class="counter-booking">
                        <span>2</span>
                    </div>
                    <p>{{language.lang('Enter your email.')}}</p>
                </div>
                <v-col :cols="oracle.isMobile() ? '12' : '5' " class="mr-auto">
                    <v-text-field rounded v-model="email" persistent-hint outlined type="email"
                                  :hint="language.lang('If the documents are approved, you will be contacted by email.')"
                    ></v-text-field>
                </v-col>
            </div>
            <div :class="oracle.isMobile() ? 'ml-2 mr-2' : 'mr-5 ml-5'" class="d-flex flex-column mt-5">
                <div class="d-flex flex-row hint-booking">
                    <div class="counter-booking">
                        <span>3</span>
                    </div>
                    <p>{{language.lang('Enter passenger details.')}}</p>
                </div>
                <v-col dir="rtl" :cols="oracle.isMobile() ? '12' : '10' " :class="index > 0 ? 'border-top' : ''"
                       class="mr-auto"
                       v-for="(item, index) in passengers" :key="index">
                    <div class="d-flex flex-row mb-2">
                        <span style="font-size: 12px; font-weight: bold; margin-right: auto">
                            {{language.lang('Passenger')}} {{index + 1}}
                        </span>
                    </div>
                    <div class="d-flex" :class="oracle.isMobile() ? 'flex-column-reverse' : 'flex-row'"
                         style="align-items: center; ">
                        <v-btn v-if="index == 0" @click="passengers.push({})"
                               color="white"
                               type="success" style="background-color: #3aaf85"
                               text-color="white" rounded class="ml-2 mr-2 mb-4 btn-booking">
                            {{language.lang('Add Passenger')}} +
                        </v-btn>
                        <v-btn v-else @click="passengers.splice(index, 1)"
                               color="white"
                               type="danger" style="background-color: #cd201f"
                               text-color="white" rounded class="ml-2 mr-2 mb-4 btn-booking">
                            {{language.lang('Remove Passenger')}} -
                        </v-btn>
                        <v-file-input
                                :style="oracle.isMobile() ? 'width: 100%' : ''"
                                rounded class="ml-2 mr-2" v-model="item.file" persistent-hint outlined
                                :hint="language.lang('The first page of the passport in PDF, PNG, JPEG format')"
                        ></v-file-input>
                        <v-text-field
                                :style="oracle.isMobile() ? 'width: 100%' : ''"
                                rounded class="ml-2 mr-2" v-model="item.id" persistent-hint outlined type="text"
                                :hint="language.lang('Passport ID')"
                        ></v-text-field>
                        <v-text-field
                                :style="oracle.isMobile() ? 'width: 100%' : ''"
                                rounded class="ml-2 mr-2" v-model="item.name" persistent-hint outlined type="text"
                                :hint="language.lang('Latin name and surname (as per passport)')"
                        ></v-text-field>
                    </div>
                </v-col>
            </div>
            <div :class="oracle.isMobile() ? 'ml-2 mr-2' : 'mr-5 ml-5'" class="d-flex flex-column mt-5">
                <div class="d-flex flex-row hint-booking">
                    <div class="counter-booking">
                        <span>4</span>
                    </div>
                    <p>{{language.lang('Explanations related to the day and time of Check-IN, as well as points to be considered during the reservation.')}}</p>
                </div>
                <v-col :cols="oracle.isMobile() ? '12' : '5' " class="mr-auto">
                    <v-textarea v-model="note" rows="5" :single-line="false" rounded persistent-hint outlined
                                :hint="language.lang('Please complete the description of the request based on the status of the Booking.com link.')"
                    ></v-textarea>
                </v-col>
            </div>
            <div class="mt-5 flex-row d-flex">
                <div style="width: 100%; height: 1px; background-color: #eeeeee;"></div>
            </div>
            <div :class="oracle.isMobile() ? 'ml-2 mr-2' : 'mr-5 ml-5'" class="d-flex flex-column mt-5">
                <div class="d-flex flex-row hint-booking">
                    <div class="counter-booking">
                        <span>5</span>
                    </div>
                    <p>{{language.lang('If the information is entered correctly, register your request.')}}</p>
                </div>
                <p class="mt-2" style="font-size: 13px">{{language.lang('System will verify your information and you will receive an email regarding your request. Please wait for 12 working hours.')}}</p>
                <base-button @click="sendRequest" class="mt-5 mb-5" :class="oracle.isMobile() ? 'ml-auto mr-auto' : ''"
                             style="width: fit-content; background-color: #427BD5" type="primary"
                             text-color="white">{{language.lang('Submit a request for reservation trial')}}
                </base-button>
            </div>
        </div>
    </section>
</template>
<script>
    import oracle from "@/utils/oracle";
    import language from "@/utils/language";

    export default {
        name: "booking",
        data: () => ({
            address: "",
            note: "",
            email: "",
            oracle: oracle,
            passengers: [{}],
            isEN: oracle.isEN(),
            language: language,
        }), watch: {},
        methods: {
            sendData(array) {
                let request = {
                    "note": this.note,
                    "email": this.email,
                    "address": this.address,
                    "passengers": array
                }
                oracle.axios('overview/booking', request, (response) => {
                    oracle.showMessage(response.message, null, null, 'checked');
                    this.passengers = [{}]
                    this.address = ""
                    this.email = ""
                    this.note = ""
                })
            },
            sendRequest() {
                let neededToUpload = 0
                let array = []
                for (let i = 0; i < this.passengers.length; i++) {
                    if (this.passengers[i] != null && this.passengers[i].file != null) {
                        neededToUpload++
                    }
                }
                for (let i = 0; i < this.passengers.length; i++) {
                    if (this.passengers[i] != null) {
                        let data = {name: this.passengers[i].name, id: this.passengers[i].id}
                        if (this.passengers[i].file != null) {
                            oracle.axiosUpload(this.passengers[i].file, (response) => {
                                neededToUpload--
                                data.picture = response.data
                                array.push(data)
                                if (neededToUpload == 0) this.sendData(array)
                            })
                        } else {
                            array.push(data)
                            if (neededToUpload == 0) this.sendData(array)
                        }
                    }
                }
            }
        },
        mounted() {
        },
    };
</script>
<style>
    .image-logo-booking {
        height: 80px;
        margin-right: 10px;
        margin-left: 10px;
        width: auto;
    }

    .title-booking {
        font-size: 13px;
    }

    .logo-booking {
        height: 75px;
        width: auto;
    }

    .counter-booking {
        width: 25px;
        height: 25px;
        min-width: 25px;
        max-width: 25px;
        color: white;
        background-color: #427BD5;
        border-radius: 100%;
        display: flex;
    }

    .counter-booking span {
        margin: auto;
    }

    .hint-booking {
        align-items: center;
    }

    .hint-booking p {
        font-size: 13px;
        font-weight: bold;
        margin-right: 10px;
        margin-left: 10px;
        margin-bottom: unset !important;
    }

    .btn-booking span {
        font-size: 11px;
        color: white;
    }

    .booking input {
        text-align: left !important;
    }

    .booking textarea {
        height: 300px;
    }

    .booking-margin {
        margin-top: -100px;
    }
</style>
